import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import SplashScreen from "../features/splashScreens/pages/SplashScreen";
import LoginPage from "../features/auth/pages/LoginPage";
import HomePage from "../features/home/pages/HomePage";
import Overlay from "../features/home/components/OverlayMenu";
import SessionPage from "../features/chat/pages/SessionPage";
import VideoSession from "../features/chat/pages/VideoSession";
import Header from "../shared/components/Header";
import ProfilePage from "../features/profile/pages/ProfilePage";
import HelpPage from "../features/profile/pages/HelpPage";
import ArchivedSessions from "../features/profile/pages/ArchivedSessions";
import "../styles/App.css";

import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const GAListener = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
};

const MainLayout = ({ children, isActive, setIsActive }) => (
  <>
    <Header isActive={isActive} setIsActive={setIsActive} />
    <main>{children}</main>
  </>
);

function App() {
  const [isActive, setIsActive] = useState(false);

  return (
    <Router>
      <GAListener />
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/archive" element={<ArchivedSessions />} />

        <Route
          path="/home"
          element={
            <MainLayout isActive={isActive} setIsActive={setIsActive}>
              <HomePage />
            </MainLayout>
          }
        />

        <Route
          path="/session"
          element={
            <MainLayout isActive={isActive} setIsActive={setIsActive}>
              <SessionPage />
            </MainLayout>
          }
        />

        <Route
          path="/vsession"
          element={
            <MainLayout isActive={isActive} setIsActive={setIsActive}>
              <VideoSession />
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
